/* eslint-disable array-callback-return */
import { File } from 'better-xlsx';
import { saveAs } from 'file-saver';

const ETitleType = {
  MAIN: 1,
  SUBMAIN: 2,
  DUMMY: 3
}

function exportTitleTable(
  column,
  dataSource,
  fileName = 'export',
  sheetName = 'Sheet1',
  cellWidths = [20, 20, 20, 20],
  excelTitle,
  arrSubTitle,
  isHigh
) {

  const file = new File();
  let sheet = file.addSheet(sheetName);
  //  gets the number of header rows 
  let depth = getDepth(column);
  //  gets the number of columns in the header 
  let columnNum = getColumns(column);
  //  initializes the title
  initTitle(column, excelTitle, arrSubTitle);
  //  new number of header rows 
  let rowArr = [];
  for (let k = 0; k < depth; k++) {
    let tempRow = sheet.addRow()
    tempRow.setHeightCM(1);
    rowArr.push(tempRow);
  }
  //  populate the cells according to the number of columns 
  rowArr.map(ele => {
    for (let j = 0; j < columnNum; j++) {
      let cell = ele.addCell();
      cell.value = j;
    }
  });
  //  initializes the header 
  if(Array.isArray(arrSubTitle)) {
    depth += (4 + arrSubTitle.length);
    init(column, 4 + arrSubTitle.length, 0);
  } else {
    depth += 10;
    init(column, 6, 0);
  }
  
  //  unfold the columns in order 
  let columnLineArr = [];
  columnLine(column);
  //  according to the column, the dataSource the data inside is sorted and converted into a two-dimensional array 
  let dataSourceArr = [];
  dataSource.map(ele => {
    let dataTemp = [];
    columnLineArr.map(item => {
      if(ele.mergeSize && ele.mergeColumn.includes(item.dataIndex)) {
        dataTemp.push({
          [item.dataIndex]: ele[item.dataIndex],
          value: ele[item.dataIndex],
          mergeSize: ele.mergeSize,
        });
      } else {
        dataTemp.push({
          [item.dataIndex]: ele[item.dataIndex],
          value: ele[item.dataIndex],
        });
      }
    });
    dataSourceArr.push(dataTemp);
  });
  // debugger;
  //  drawing table data 
  dataSourceArr.forEach((item, index) => {
    // according to the data, create the corresponding number of rows
    let row = sheet.addRow();
    let rowHeightCM = 0.8;
    row.setHeightCM(rowHeightCM);
    // creates a cell for that number
    item.map(ele => {
      let cell = row.addCell();
      if(ele.mergeSize) {
        cell.vMerge = ele.mergeSize-1;
      }
      if (ele.hasOwnProperty('num')) {
        cell.value = index + 1;
      } else {
        if(isHigh) {
          if(ele.value.toString().indexOf('|||H|||') > -1) {
            let eleValue = ele.value.replaceAll('|||H|||', '');
            if(isNaN(eleValue)) {
              cell.value = eleValue;
            } else {
              cell.value = parseFloat(eleValue);
            }
            cell.style.font.color = 'FFFF0000';
            cell.style.font.bold = true;
          } else {
            cell.value = ele.value;
          }
        } else {
          if (ele.value) {
            if (Array.isArray(ele.value)) {
              // 셀 cm 최대 값
              const max = Math.max((row.height / 28.3464567), rowHeightCM + (ele.value.length));
              row.setHeightCM(max);
              cell.style.align.wrapText = true
              cell.value = ele.value?.join("\n");
            } else if(ele.value.toString().indexOf('\n') > -1) {
              row.setHeightCM(5);
              cell.style.align.wrapText = true;
              cell.value = ele.value;
            } else {
              cell.value = ele.value;
            }
          }
        }
      }
      cell.style.align.v = 'center';
      cell.style.align.h = 'center';
    });
  });
  // set the width of each column 
  for (var i = 0; i < cellWidths.length; i++) {
    sheet.col(i).width = cellWidths[i];
  }
  file.saveAs('blob').then(function (content) {
    saveAs(content, fileName + '.xlsx');
  });

  //  unfold the columns in order 
  function columnLine(column) {
    column.map(ele => {
      if (ele.children === undefined || ele.children.length === 0) {
        columnLineArr.push(ele);
      } else {
        columnLine(ele.children);
      }
    });
  }

  //  initializes the title
  function initTitle(column, title, arrSubTitle) {
    let mergeSize = 0;
    
    column.map((item, index) => {
      if(item.children !== undefined && item.children.length !== 0) {
        item.children.map((item, index) => {
          mergeSize += 1;
        })
      } else {
        mergeSize += 1;
      }
    });

    if(!mergeSize) {
      mergeSize = column.length - 1;
    } else {
      mergeSize -= 1;
    }

    makeTitle(mergeSize, '', 0.5, ETitleType.DUMMY);
    makeTitle(mergeSize, title, 2, ETitleType.MAIN);
    makeTitle(mergeSize, '', 0.5, ETitleType.DUMMY);
    arrSubTitle.forEach(function(subTitle) {
      makeTitle(mergeSize, subTitle, 0.8, false, ETitleType.SUBMAIN);
    });
    makeTitle(mergeSize, '', 0.5, ETitleType.DUMMY);
  }

  function makeTitle(mergeSize, title, cellHeight, mainType) {
    let row = sheet.addRow();
    row.setHeightCM(cellHeight);
    let cell = row.addCell();
    cell.value = title;
    cell.style.border.top = 'thin'
    cell.style.border.topColor = 'ffffff';
    
    cell.hMerge = mergeSize;
    if(mainType !== ETitleType.DUMMY) {
      cell.style.align.v = 'center';
    }

    if(mainType === ETitleType.MAIN) {
      cell._style.font.bold = true;
      cell._style.font.size = 20;
      cell.style.align.h = 'center';
    }
  }

  //  initializes the header 
  function init(column, rowIndex, columnIndex) {
    column.map((item, index) => {
      let hCell = sheet.cell(rowIndex, columnIndex);
      //  if there are no child elements,   all the columns 
      if (item.title === ' operation ') {
        hCell.value = '';
        return;
      } else if (item.children === undefined || item.children.length === 0) {
        //  add a cell to the first row 
        hCell.value = item.title;
        hCell.vMerge = depth - rowIndex - 1;
        hCell.style.align.h = 'center';
        hCell.style.align.v = 'center';
        columnIndex++;
        // rowIndex++
      } else {
        let childrenNum = 0;
        function getColumns(arr) {
          arr.map(ele => {
            if (ele.children) {
              getColumns(ele.children);
            } else {
              childrenNum++;
            }
          });
        }
        getColumns(item.children);
        hCell.hMerge = childrenNum - 1;
        hCell.value = item.title;
        hCell.style.align.h = 'center';
        hCell.style.align.v = 'center';
        let rowCopy = rowIndex;
        rowCopy++;
        init(item.children, rowCopy, columnIndex);
        //  next cell start 
        columnIndex = columnIndex + childrenNum;
      }
    });
  }
  //  gets table head rows 
  function getDepth(arr) {
    const eleDepths = [];
    arr.forEach(ele => {
      let depth = 0;
      if (Array.isArray(ele.children)) {
        depth = getDepth(ele.children);
      }
      eleDepths.push(depth);
    });
    return 1 + max(eleDepths);
  }

  function max(arr) {
    return arr.reduce((accu, curr) => {
      if (curr > accu) return curr;
      return accu;
    });
  }
  //  calculates the number of header columns 
  function getColumns(arr) {
    let columnNum = 0;
    arr.map(ele => {
      if (ele.children) {
        getColumns(ele.children);
      } else {
        columnNum++;
      }
    });
    return columnNum;
  }

  // Cell 배경색 스타일 주고 싶을 때 사용
  function setCellStyleBackground(cell, color) {
    const _color = color.includes("#") ? color.replace('#', '') : color;

    cell.style.fill.fgColor = _color;
    cell.style.fill.bgColor = _color;
    cell.style.fill.patternType = 'solid';
  }
}

export default exportTitleTable;
